import styled from 'styled-components';

export const StyledCheckoutConfirmationContainer = styled.main`
  min-height: 100vh;
  background: ${props => props.theme.colors.background.base};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ConfirmationHeroContainer = styled.div`
  width: 100%;
`;

export const AccountFeaturesContainer = styled.div`
  width: 100%;
`;

export const ConfirmationOrderSummaryContainer = styled.div`
  transition: 500ms all ease;
  margin-bottom: ${props => props.theme.spacing(7.5)};
  max-width: 900px;
  width: 100%;
`;

export const SplitPanelsContainer = styled.div`
  margin: ${({ theme }) => theme.spacing(6, 0)};
  width: 100%;

  @media ${({ theme }) => theme.tablet} {
    margin: ${({ theme }) => theme.spacing(7, 0, 16, 0)};
  }
`;

export const ButtonWrap = styled.div`
  margin-top: ${({ theme }) => theme.spacing(6)};
`;

export const OllieAppBannerContainer = styled.div`
  margin: ${({ theme }) => theme.spacing(0, 0, 12, 0)};
  max-width: 900px;
  width: 100%;

  @media ${({ theme }) => theme.tablet} {
    div {
      &:first-of-type {
        margin-top: 0;
      }
    }
  }
`;
